// extracted by mini-css-extract-plugin
export default {"container":"PlQOeGBaMUbA4clpp1hS","remotelyInfo":"oAYersr6whI2XaanhfzF"};